import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';
import './Shop.css';

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const LIMIT = 12;

  const category = searchParams.get('category') || 'all';
  const search   = searchParams.get('search')   || '';
  const sort     = searchParams.get('sort')     || 'newest';

  useEffect(() => {
    api.get('/products/categories').then(r => setCategories(r.data.categories)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ limit: LIMIT, page, sort });
    if (category !== 'all') params.set('category', category);
    if (search) params.set('search', search);

    api.get(`/products?${params}`)
      .then(r => { setProducts(r.data.products); setTotal(r.data.total); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category, search, sort, page]);

  const setParam = (key, val) => {
    const next = new URLSearchParams(searchParams);
    if (val) next.set(key, val); else next.delete(key);
    next.delete('page');
    setSearchParams(next);
    setPage(1);
  };

  const pages = Math.ceil(total / LIMIT);

  return (
    <div>
      <div className="page-hero">
        <div className="container">
          <h1>Research Compounds</h1>
          <p>Premium peptides and research chemicals — 3rd party tested, verified purity</p>
        </div>
      </div>

      <div className="container shop-layout">
        {/* Sidebar */}
        <aside className="shop-sidebar">
          <div className="shop-sidebar__section">
            <h3>Categories</h3>
            <button className={`cat-btn${category === 'all' ? ' active' : ''}`} onClick={() => setParam('category', '')}>
              All Products <span>({total})</span>
            </button>
            {categories.map(c => (
              <button key={c.id} className={`cat-btn${category === c.id ? ' active' : ''}`} onClick={() => setParam('category', c.id)}>
                {c.name}
              </button>
            ))}
          </div>

          <div className="shop-sidebar__section">
            <h3>Sort By</h3>
            {[['newest','Newest'],['price_asc','Price: Low→High'],['price_desc','Price: High→Low'],['rating','Top Rated'],['name','Name A-Z']].map(([v, l]) => (
              <button key={v} className={`cat-btn${sort === v ? ' active' : ''}`} onClick={() => setParam('sort', v)}>{l}</button>
            ))}
          </div>
        </aside>

        {/* Main */}
        <main className="shop-main">
          <div className="shop-toolbar">
            <span className="shop-count">{total} products</span>
            <div className="shop-search">
              <input
                className="form-input"
                placeholder="Search products…"
                defaultValue={search}
                onKeyDown={e => { if (e.key === 'Enter') setParam('search', e.target.value); }}
              />
            </div>
          </div>

          {loading ? (
            <div className="loading-center"><div className="spinner" /></div>
          ) : products.length === 0 ? (
            <div className="shop-empty">
              <p>🔭 No products found. <button onClick={() => setSearchParams({})}>Clear filters</button></p>
            </div>
          ) : (
            <div className="grid-3">
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}

          {/* Pagination */}
          {pages > 1 && (
            <div className="pagination">
              {Array.from({ length: pages }, (_, i) => i + 1).map(n => (
                <button key={n} className={`page-btn${n === page ? ' active' : ''}`} onClick={() => setPage(n)}>{n}</button>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
